import s from "./Products.module.css";

const ProductInfo = () => {
    return (<div className={s.productInfo}>
        <div>
            <h3>В НОГУ СО ВРЕМЕНЕМ: КУПИТЬ ПОСТЕЛЬНОЕ БЕЛЬЕ БЯЗЬ-РАНФОРС</h3>
            <p>Маркетинг - величайшая наука, которая ежедневно самоутверждается и развивается на нас с вами.
                Наибольшее количество товаров, которые люди приобретают ежеминутно - результат рекламы и
                грамотной подачи, что принято называть маркетинговых ходом. Аптеки, магазины косметики,
                рестораны и фитнес-центры предлагают нам то, от чего мы не сможем отказаться. В эту ловушку
                попадают и покупатели постельного белья, подразумевая, что за новомодным словом "ранфорс"
                скрывается инновационный комплект для сна. Тем временем, данным названием наградили привычную
                многим бязь. Это совершенно не означает, что хлопковый материал, именуемый "бязь" менее
                качественный. Просто за новым названием теряется привычное понимание того, что же собой
                представляет эта постельная ткань.
            </p>
        </div>
        <div>
            <h3>КАК ПРАВИЛЬНО ВЫБРАТЬ И КУПИТЬ ПОСТЕЛЬНОЕ БЕЛЬЕ БЯЗЬ-РАНФОРС</h3>
            <p>Несмотря на красивое название, разработанное турецкими маркетологами для продвижения популярных
                постельных комплектов, давайте разъясним, что же собой представляет бязь.
            </p>
            <ol>
                <li>Качественное белье для сна из бязи - это 100% натуральные волокна хлопка.</li>
                <li>Дешево может стоить постель более низкого качества, где производитель допускает до двадцати
                    процентов полиэстеровых нитей. Это искусственный продукт, который получают путем синтеза
                    химического характера из веществ глубокой переработки углеводородов.
                </li>
                <li>Данные о том, из чего состоит комплект следует внимательно читать на этикетке или покупать у
                    проверенного производителя.
                </li>
                <li>Важно знать состав особенно тем людям, которые имеют повышенную чувствительность к синтетике
                    и аллергические реакции на нее.
                </li>
            </ol>
        </div>
        <div>
            <h3>ПРОВЕРЯЕМ КАЧЕСТВО ПРЕЖДЕ, ЧЕМ КУПИТЬ ПОСТЕЛЬНОЕ БЕЛЬЕ БЯЗЬ-РАНФОРС</h3>
            <p>Хорошее постельное ранфорс являет собой плотную ткань, которая получается путем полотняного
                плетения крученых нитей и утка. Стоит она недорого в сравнении с другими спальными наборами. При
                этом, несмотря на особенности производства, предполагается повышенная плотность, товар
                отличается шелковистой фактурой и мягкостью. Из характерных качеств бязевого постельного стоит
                отметить:
            </p>
            <ul>
                <li>долговечность</li>
                <li>мягкость</li>
                <li>прочность</li>
                <li>комфорт</li>
                <li>гигроскопичность</li>
                <li>воздухопроницаемость</li>
                <li>гигиеничность</li>
                <li>простота в уходе</li>
                <li>несминаемость</li>
            </ul>
            <p>Здоровый сон - залог хорошего физического и психоэмоционального состояния человека. Именно
                поэтому условия для сна должны быть соблюдены с максимальным вниманием к деталям:
            </p>
            <ul>
                <li>Начиная от расположения кровати в спальной комнате и плотностью оконных штор.
                </li>
                <li> А постельное белье и подушки требуют самого трепетного отношения.
                </li>
                <li>Мягкая приятная постель создает ощущение уюта и стабильности. Располагают к полноценному
                    отдыху.
                </li>
            </ul>
            <p>Расцветка постельного комплекта тоже имеет большое значение. Для кого-то важно, чтобы она
                гармонировала с общими тонами интерьера спальной комнаты. Другие же выбирают графические
                рисунки, абстрактные картины или цветы. А есть и те, кому больше всего импонирует однотонное
                постельное. Все это дело вкуса и ассортимента магазина. К счастью, ассортимент товара позволяет
                удовлетворить даже самого требовательного клиента.

                Часто покупателей даже для частного пользования интересует не только розница, но и покупка
                оптом. Наш интернет-магазин предлагает любой, удобный потребителю вариант заказа. Да и цена
                будет приятным сюрпризом.

                Удобным фактом является доставка, которая осуществляется в город Полтава и не только. Вся
                Украина может получать продукцию с нашего сайта, оформив доставку. Не стоит жертвовать своим
                комфортом. Выбирайте качество и удобство! А о достойном ассортименте мы уже позаботились!
            </p>
        </div>
    </div>)
}

export default ProductInfo;